import { Box, Flex, Text } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { tracking } from '#features/analytics';
import { Link } from '#features/routing';
import { Button } from '#features/ui';

type CtaProps = {
  accentColor: string;
};

export const Cta = ({ accentColor }: CtaProps) => {
  const { t } = useLingui();

  return (
    <Box as="section" aria-label="Call to Action" position="relative" w="100%">
      <Box
        position="absolute"
        top="-70px"
        left="50%"
        transform="translateX(-50%)"
        w="360px"
        h="360px"
        background={`radial-gradient(circle, ${accentColor}26 0%, transparent 70%)`}
        pointerEvents="none"
      />
      <Flex
        direction="column"
        alignItems="center"
        gap={5}
        py={{ base: 12, md: 16 }}
        px={{ base: 6, md: 12 }}
        background="linear-gradient(165deg, hsla(228, 11.6%, 15%, 0.85) 0%, hsla(228, 11.6%, 9%, 0.5) 100%)"
        border="1px solid"
        borderColor="whiteAlpha.100"
        borderRadius="3xl"
        textAlign="center"
        position="relative"
        overflow="hidden"
      >
        <Box
          position="absolute"
          top={0}
          left="10%"
          right="10%"
          h="1px"
          background={`linear-gradient(90deg, transparent, ${accentColor}88, transparent)`}
        />
        <Text
          fontSize={{ base: '3xl', md: '5xl' }}
          lineHeight="1.02"
          maxW="620px"
          fontWeight="900"
          textTransform="uppercase"
          letterSpacing="-0.02em"
        >
          {t`v2.cta.title`}
        </Text>
        <Text fontSize="md" color="fg.muted" maxW="440px">
          {t`v2.cta.subtitle`}
        </Text>
        <Button
          minW="240px"
          w={{ base: '100%', md: 'auto' }}
          size="lg"
          mt={2}
          style={{ boxShadow: `0 0 28px ${accentColor}59` }}
          onClick={() => tracking.event({ action: 'click_get_started' })}
          asChild
        >
          <Link to="/{-$locale}/sign-up">{t`v2.cta.button`}</Link>
        </Button>
      </Flex>
    </Box>
  );
};
